<core-data-grid class="core-value-list" [(dataSource)]="dataSource" [columns]="columns" [props]="props"></core-data-grid>
